import "./TextArea.scss";
import {
  MotifTextArea,
  MotifFormField,
  MotifErrorMessage,
} from "../../../assets/lib/motif";

export function TextArea({
  label,
  onChange,
  value,
  maxLength,
  id = crypto.randomUUID(),
  className,
  required = false,
  disabled = false,
  placeholder = "",
  isError,
  errorMessage,
  disableErrorPlaceholder = true,
  ...other
}) {
  function onInputChange(event) {
    const value = event.target?.value;
    if (value.includes("</") || value.includes(">") || value.includes("<")) {
      event.target.value = value.replace(/[<>/]/g, "");
      return;
    }
    if (event.target?.value) {
      if (maxLength && event.target?.value.length <= maxLength) {
        onChange(event);
      }
    }

    onChange(event);
  }
  return (
    <MotifFormField className="decarb-text-area">
      <MotifTextArea
        {...other}
        id={id}
        label={label}
        onChange={onInputChange}
        value={value}
        maxLength={maxLength}
        className={`${className}`}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
      />
      {isError ? (
        <MotifErrorMessage className="decarb-input-error-message">
          {errorMessage}
        </MotifErrorMessage>
      ) : !disableErrorPlaceholder ? (
        <div className="decarb-input-hide-error">No Error</div>
      ) : (
        <></>
      )}
    </MotifFormField>
  );
}
